// extracted by mini-css-extract-plugin
module.exports = {"root":"Slider_root__AiRlA","track":"Slider_track__PmS0S","range":"Slider_range__M3UMC","thumb":"Slider_thumb___yWQn"};